import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'

export default function Repent() {
  return (
    <PageLayout>
      <div className="book-page">
        <h1>Repent and Confess Your Sins to God.</h1>
        <blockquote>“He who conceals his transgressions will not prosper, But he who confesses and forsakes them will find compassion.” (Proverbs 28:13)</blockquote>

<p>Repentance and confession play a critical role in overcoming temptation. God commands that we confess our sins to Him and to one another (<em>1 John 1:6-10, James 5:16</em>) and repent (<em>Revelation 3:19</em>). According to John, denying we are sinners is calling God a liar. Confessing our sins is humbling, and it requires us to think through and articulate exactly what we have done that is wrong. Even though God already knows about our sins, at times it is difficult to acknowledge them to Him and confess and ask His forgiveness. Pride and self-righteousness get in the way, as it is far easier to make excuses or justify our sin to ourselves and others than it is to confess that we are wrong. At other times we sin and don’t even realize it, because we are ignorant or forgetful of the scriptures, or we have become callous. Whatever the reason, sin that is not confessed and forsaken creates a barrier between us and God, hinders our fellowship with Him, and provokes Him (<em>Isaiah 59:2</em>). Repentance, similar to confession, is a turning away from sin, a rejection of sinful behavior and commitment to follow God’s commandments. Whereas confession is a one time act after we sin, repentance involves ongoing action to keep ourselves from sin in the future. How to do this is covered in more detail throughout this booklet. Another important aspect of confession is to confess our sins to those we have offended and ask their forgiveness, with all sincerity and without trying to lay blame on anyone else. The next steps we must take to get right with God and overcome temptation are to confess our sins and repent.</p>

<ul>
  <li><strong>Confess your sins to God quickly; do not justify them or make excuses for them.</strong><br />
  <em>Psalm 25:7, 11, 18, 32:5, 38:18, 51:1-19, 79:8-9, Proverbs 20:9, 28:13, 1 John 1:8-10, Revelation 2:4-5, 3:3, 19</em></li>

  <li><strong>Realize that you have a merciful and sympathetic Advocate, Jesus Christ.</strong><br />
  <em>Hebrews 2:17-18, 4:15-16, 9:14, 1 John 2:1-2, Revelation 3:19-20</em></li>

  <li><strong>Receive God’s chastening and give thanks for it.</strong><br />
  <em>Psalm 94:12, 119:75, Proverbs 3:11-12, Jeremiah 5:3, 10:24, Hebrews 12:5-11</em></li>

  <li><strong>God already knows your sin but wants you to acknowledge it yourself. Realize that confession, repentance, and forgiving others are prerequisite to enjoying God’s forgiveness and blessing.</strong><br />
  <em>Proverbs 28:13, Isaiah 30:15, Jeremiah 3:11-14, Matthew 6:12-15, 18:21-35, 1 John 1:8-10</em></li>

  <li><strong>Confess your sins to others, as a public testimony and so that they may help you.</strong><br />
  <em>Acts 19:18, James 5:16</em></li>

  <li><strong>Hate sin as God hates it; see evil as He sees it.</strong><br />
  <em>Psalm 51:3-4, 97:10, 119:104, 128, 163, Proverbs 6:16-19, 16:5, Amos 5:14-15, Revelation 2:6</em></li>

  <li><strong>Repent of pride, self-centeredness, grumbling, and hardness of heart.</strong><br />
  <em>1 Samuel 15:23, Psalm 78:7-38, Proverbs 8:13, Jeremiah 4:4, Luke 18:9-14, 1 Corinthians 8:1-3, 10:9-12</em></li>

  <li><strong>Repent of lust and immoral thoughts and behavior.</strong><br />
  <em>Matthew 5:28, 1 Corinthians 6:9-11, 18-20, 10:6-8, Ephesians 5:3, Colossians 3:5-6</em></li>

  <li><strong>Repent of drunkenness, foolishness, unwholesome words, and wasted time.</strong><br />
  <em>Psalm 90:12, Proverbs 14:16, 23:29-35, Ephesians 4:29, 5:4, 14-18</em></li>

  <li><strong>Repent of a love of money, coveting, greed, and loving the things of the world.</strong><br />
  <em>Exodus 20:17, Mark 8:34-38, Luke 12:15, Colossians 3:5, 1 Timothy 6:9-11, Hebrews 13:5, 1 John 2:15-17</em></li>

  <li><strong>Repent of anger, fear, anxiety, lying, and all other evil thoughts, words, and actions.</strong><br />
  <em>Exodus 20:1-17, Proverbs 16:32, Matthew 5:22, Ephesians 4:25-32, Colossians 3:8-10</em></li>

  <li><strong>Take responsibility for your actions; don’t blame your sin on God or others.</strong><br />
  <em>Job 42:1-6, 1 Corinthians 10:13, James 1:13-16, 2 Peter 1:3</em></li>

  <li><strong>Realize that when you sin, you sin against God.</strong><br />
  <em>Psalm 51:4</em></li>
</ul>
      </div>
    </PageLayout>
  );
};
